export default __webpack_public_path__ + "static/media/profile_active.eba5f2d5.svg";